<template>
  <v-content>
    <v-card v-if="NoData" class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px">
        ไม่พบข้อมูลการจัดประชุม โปรดตรวจสอบ URL อีกครั้ง
      </span>
    </v-card>
    <v-card v-if="MeetingData.length > 0 && this.MeetingData[0].Reg_status == '0'"
            class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: red" v-if="MeetingData.length > 0">
         {{ this.MeetingData[0].Topic }} ปิดการรับสมัคร
      </span>
    </v-card>
    <v-card v-else>
      <v-app-bar
          absolute
          color="pink"
          dark
          fixed
      >
        <v-spacer></v-spacer>

        <v-toolbar-title class="font-weight-bold text-md-h3 text-h4" v-if="MeetingData.length > 0">
          {{ this.MeetingData[0].Topic }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

      </v-app-bar>
      <v-card-text v-if="MeetingData.length > 0">
        <v-list class="mt-10">
          <v-list-item class="justify-center">
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="8"
              >
                <v-list-item>
                  <span class="font-weight-bold text-md-h6">
              หัวข้อประชุม : {{ this.MeetingData[0].Topic }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <span class="font-weight-bold text-md-h6">
              สถานที่จัด : {{ this.MeetingData[0].Place }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6"
                         v-if="MeetingData[0].Date_start == MeetingData[0].Date_end">
              วันที่จัด : {{ this.MeetingData[0].Date_start | DateToThai }} เวลา {{ this.MeetingData[0].Time_start }} น. - {{
                       this.MeetingData[0].Time_end
                     }} น.
            </span>
                  <span class="font-weight-bold text-md-h6" v-else>
              วันที่จัด : {{
                      this.MeetingData[0].Date_start | DateToThai
                    }} - {{ this.MeetingData[0].Date_end | DateToThai }} | เวลา {{ this.MeetingData[0].Time_start }} น. - {{
                      this.MeetingData[0].Time_end
                    }} น.
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6"
                         v-if="MeetingData[0].Date_reg_start == MeetingData[0].Date_reg_end">
              วันที่เปิดลงทะเบียน : {{
                       this.MeetingData[0].Date_reg_start | DateToThai
                     }} จำนวนผู้เข้าร่วม {{
                       (MeetingData[0].Count_cordi == '0' ? 'ไม่จำกัด' : MeetingData[0].Count + ' คน')
                     }}
            </span>
                  <span class="font-weight-bold text-md-h6" v-else>
              วันที่เปิดลงทะเบียน : {{
                      this.MeetingData[0].Date_reg_start | DateToThai
                    }} - {{ this.MeetingData[0].Date_reg_end | DateToThai }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6">
              จำกัดผู้เข้าร่วม : {{ (MeetingData[0].Count_cordi == '0' ? 'ไม่จำกัด' : MeetingData[0].Count + ' คน') }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6">
              รายละเอียดเพิ่มเติม :
                     <v-btn text color="primary" @click="dialogDetail = true">
                     Click!!
                   </v-btn>
            </span>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item>
          <div v-if="MeetingData[0].Date_reg_end >= formatDateNow()">
            <div align="center">
            <span class="font-weight-bold text-md-h5" style="color: #42b983">
              ส่งรายชื่อร่วมประชุม
            </span>
            </div>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="6">
                  <v-autocomplete
                      v-model="staffSel"
                      label="ค้นหาบุคลากร"
                      :items="staffDataDump"
                      item-text="customDetail"
                      item-value="perid"
                      hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                      persistent-hint
                      clearable
                      outlined
                      :disabled="dialogLoading"
                      @keyup="checkKeyEnter"
                  ></v-autocomplete>
                </v-col>
                <v-col
                    cols="12"
                    md="2">
                  <v-btn
                      class="mt-2"
                      outlined
                      color="primary"
                      :disabled="dialogLoading"
                      @click="InsertJoinMeet">
                    เพิ่ม
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </div>
          <div v-else>
            <div align="center">
            <span class="font-weight-bold text-md-h5" style="color: darkred">
              หมดเขตการรับสมัคร
            </span>
            </div>
          </div>
          <v-list-item>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="ค้นหา"></v-text-field>
          </v-list-item>
          <div align="center" style="font-size: 20px">
            ผู้เข้าร่วมทั้งหมด {{ JoinMeet.length }} /
            {{ (MeetingData[0].Count_cordi == '0' ? 'ไม่จำกัด' : MeetingData[0].Count) }} คน |
            ลงทะเบียน <span
              style="font-weight: bold;color: #42b983">{{
              JoinMeet.filter(item => item.status_reg == '1').length
            }}</span>
            คน / รอลงทะเบียน <span
              style="font-weight: bold;color: red">{{
              JoinMeet.filter(item => item.status_reg == '0').length
            }}</span>
            คน
          </div>
          <v-list-item class="d-flex justify-center mt-6">
            <v-data-table
                :search="search"
                :headers="JoinMeetHeader"
                :items="JoinMeet">
              <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
              </template>
              <template v-slot:item.status_reg="{item}">
                <span style="font-weight: bold;color: #42b983" class="darken-4" v-if="item.status_reg == '1'">
                  ลงทะเบียน
                </span>
                <span style="font-weight: bold;color: red" class="darken-4" v-else>
                  รอลงทะเบียน
                </span>
              </template>
              <template v-slot:item.action="{item}">
                <v-btn color="red"
                       @click="DelData(item.idx, item)"
                       outlined
                       v-if="(MeetingData[0].Date_reg_end >= formatDateNow()) && (item.status_reg == '0') && (item.dep_group_id == MeData[0].dep_group_id)"
                >
                  ลบ
                </v-btn>
              </template>
            </v-data-table>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="dialogLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogDetail"
        width="800"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          รายละเอียดประกอบ (เพิ่มเติม)
        </v-card-title>
        <v-card-text class="mt-6" v-if="MeetingData.length > 0">
          <template v-if="MeetingData[0].Cordi == '1'">
            <div class="mt6">
              <span style="font-weight: bold;color: blue">เงื่อนไขการเข้าร่วมประชุม</span>
            </div>
            <template
                v-if="MeetingData[0].Cordi_Join_Data.target.length > 0 && MeetingData[0].Cordi_Join_Data.target[0].type == '1'">
              <div align="center">
                <span style="font-weight: bold;color: red">เฉพาะกลุ่มผู้บริหาร,หัวหน้า</span>
              </div>
              <v-divider></v-divider>
            </template>
            <template v-else>
              <template v-if="DataCondi.length > 0">
                <div class="ml-4">
                  <span style="font-weight: bold;color: #42b983">ตำแหน่ง</span>
                </div>
                <div v-for="(posi, idx) in DataCondi" v-bind:key="idx" class="ml-4">
                  <span style="color: black">{{ posi.PosName }}</span> <span style="margin-left: 20px;color: red"> อายุงาน {{
                    posi.workAgeStart
                  }} - {{ posi.workAgeEnd }} ปี</span>
                </div>
              </template>
              <template v-else>
                <div align="center">
                  <span style="font-weight: bold;color: red">ทุกตำแหน่งสามารถเข้าร่วมประชุมได้</span>
                </div>
              </template>
              <v-divider></v-divider>
              <template v-if="DepQuotaData.length > 0">
                <div class="ml-4">
                  <span style="font-weight: bold;color: #42b983">หน่วยงาน</span>
                </div>
                <div v-for="(dep, idx) in DepQuotaData" v-bind:key="idx" class="ml-4">
                  <span
                      style="color: black">{{ dep.dep_type == '0' ? 'หน่วยงาน' : 'กลุ่มหน่วยงาน' }} {{
                      dep.dep_name
                    }}</span>
                  <span style="margin-left: 20px;color: red">จำนวน {{ dep.count }} คน</span>
                </div>
              </template>
              <template v-else>
                <div align="center">
                  <span style="font-weight: bold;color: red">ทุกหน่วยงานสามารถเข้าร่วมประชุมได้</span>
                </div>
              </template>
              <v-divider></v-divider>
            </template>
          </template>
          <div class="mt6">
            <span style="font-weight: bold;color: blue">รายละเอียดประกอบ</span>
          </div>
          <div v-if="MeetingData[0].Rm != ''">
            <span style="font-size: 20px;color: black">{{ MeetingData[0].Rm }}</span>
          </div>
          <div align="center" v-else>
            <span style="font-weight: bold;color: red">ไม่มีรายละเอียดประกอบเพิ่มเติม</span>
          </div>
          <v-divider></v-divider>
          <div class="mt6">
            <span style="font-weight: bold;color: blue">ไฟล์ประกอบ</span>
          </div>
          <div v-if="FileMeetingToDb.length > 0">
            <div v-for="(file, idx) in FileMeetingToDb" :key="idx">
              <v-btn text @click="ShowData(Openfile + file.File_path)" color="blue"
                     class="text--darken-4">
                ไฟล์ที่ {{ idx + 1 }} : {{ file.File_name }}
              </v-btn>
            </div>
          </div>
          <div align="center" v-else>
            <span style="font-weight: bold;color: red">ไม่มีข้อมูลไฟล์ประกอบเพิ่มเติม</span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="red"
              text
              @click="dialogDetail = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
import queryString from "query-string";
import Const from "@/const/Const";

export default {
  name: "JoinMeeting",
  data() {
    return {
      QuotaDepCount: 0,
      DataCondi: [],
      DepQuotaData: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      staffDataDump: [],
      dialogDetail: false,
      NoData: false,
      FileMeetingToDb: [],
      staffSel: '',
      search: '',
      dialogLoading: false,
      JoinMeetHeader: [
        {text: 'รหัสอ้างอิง', value: 'uid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'},
        {text: '', value: 'action'}
      ],
      JoinMeet: [],
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      headerAxiosDel: {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      MeetingData: 'Meeting/getMeetingData',
      JoinMeetingData: 'Meeting/getJoinMeetingData',
      FilesData: 'Meeting/getFileData',
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      depart: 'Depart/getDepart',
      positions: 'Staff/getPosition',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initMeetingData: 'Meeting/initMeetingData',
      getMeetingData: 'Meeting/getMeetingData',
      initJoinMeetingData: 'Meeting/initJoinMeetingData',
      initFileData: 'Meeting/initFileData',
      initPositionsData: 'Staff/initPositionsData',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      saveSessions: 'Staff/saveSessions',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    init() {
      this.staffDataDump = []
      this.DataCondi = []
      this.DepQuotaData = []
      this.initPositionsData()
      this.initGroup_Quota_Ms()
      this.initDepartData()
      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
            // this.staffDataDump = this.staffData.filter(item => item.dep_group_name == this.MeData[0].dep_group_name)
            this.staffDataDump = this.staffData
          }
        }
      })
      this.updateDBservice()
      /*      this.getMeetingData({
              uuid: this.$route.params.uuid
            }).then(res => {
              if (res) {
                if (this.MeetingData.length > 0) {
                  this.initJoinMeetingData({
                    uuid: this.$route.params.uuid
                  }).then(res => {
                    if (res) {
                      this.JoinMeet = this.JoinMeetingData
                      this.JoinMeet.map((item, idx) => {
                        item.idx = idx + 1
                        item.IsDb = true
                      })
                    }
                  })
                  this.initFileData({
                    Ref_id: this.MeetingData[0].Ref_id
                  }).then(res => {
                    if (res) {
                      this.FileMeetingToDb = this.FilesData
                    }
                  }).catch(resErr => {
                    if (resErr) {
                      this.FileMeetingToDb = []
                    }
                  })

                  if (this.MeetingData[0].Cordi_Join_Data.position.length > 0) {
                    this.MeetingData[0].Cordi_Join_Data.position.map(itemP => {
                      this.positions.map((posi) => {
                        if (posi.PosCode == itemP.PosCode) {
                          this.DataCondi.push({
                            ...posi,
                            id: itemP.id,
                            workAgeStart: itemP.WSYear,
                            workAgeEnd: itemP.WEYear,
                          })
                        }
                      })
                    })
                  }
                  if (this.MeetingData[0].Cordi_Join_Data.depart.length > 0) {
                    this.MeetingData[0].Cordi_Join_Data.depart.map(itemDep => {
                      this.QuotaDepCount += parseInt(itemDep.count)
                      this.DepQuotaData.push({
                        ...itemDep,
                        quotaType: itemDep.dep_type,
                        type: itemDep.dep_type == '0' ? 'หน่วยงาน/ภาควิชา' : 'กลุ่มหน่วยงาน/กลุ่มภาควิชา',
                        type_id: itemDep.dep_type,
                        dep_name: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_name,
                        dep_id: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_id,
                        dep_group_id: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_group_id,
                        count: itemDep.count
                      })
                    })
                  }
                }
                this.dialogLoading = false
                // console.log(this.MeetingData)
              }
            }).catch(res => {
              if (res) {
                this.dialogLoading = false
                this.NoData = true
              }
            })*/
      // console.log(this.$route.params.uuid)
    },
    updateDBservice() {
      setInterval(() => {
        this.getMeetingData({
          uuid: this.$route.params.uuid
        }).then(res => {
          if (res) {
            if (this.MeetingData.length > 0) {
              this.initJoinMeetingData({
                uuid: this.$route.params.uuid
              }).then(res => {
                if (res) {
                  this.JoinMeet = this.JoinMeetingData
                  this.JoinMeet.map((item, idx) => {
                    item.idx = idx + 1
                    item.IsDb = true
                    item.full_Name = item.name + ' ' + item.sname
                    item.idCard = item.id_card
                  })
                }
              }).catch(res => {
                if (res) {
                  this.JoinMeet = this.JoinMeetingData
                }
              })
              this.initFileData({
                Ref_id: this.MeetingData[0].Ref_id
              }).then(res => {
                if (res) {
                  this.FileMeetingToDb = this.FilesData
                }
              }).catch(resErr => {
                if (resErr) {
                  this.FileMeetingToDb = []
                }
              })

              if (this.MeetingData[0].Cordi_Join_Data.position.length > 0) {
                this.MeetingData[0].Cordi_Join_Data.position.map(itemP => {
                  this.positions.map((posi) => {
                    if (posi.PosCode == itemP.PosCode) {
                      this.DataCondi.push({
                        ...posi,
                        id: itemP.id,
                        workAgeStart: itemP.WSYear,
                        workAgeEnd: itemP.WEYear,
                      })
                    }
                  })
                })
              }
              if (this.MeetingData[0].Cordi_Join_Data.depart.length > 0) {
                this.MeetingData[0].Cordi_Join_Data.depart.map(itemDep => {
                  this.QuotaDepCount += parseInt(itemDep.count)
                  this.DepQuotaData.push({
                    ...itemDep,
                    quotaType: itemDep.dep_type,
                    type: itemDep.dep_type == '0' ? 'หน่วยงาน/ภาควิชา' : 'กลุ่มหน่วยงาน/กลุ่มภาควิชา',
                    type_id: itemDep.dep_type,
                    dep_name: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_name,
                    dep_id: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_id,
                    dep_group_id: this.depart.filter(itemDep2 => itemDep2.dep_id == itemDep.dep_id)[0].dep_group_id,
                    count: itemDep.count
                  })
                })
              }
            }
            this.dialogLoading = false
            // console.log(this.MeetingData)
          }
        }).catch(res => {
          if (res) {
            this.dialogLoading = false
            this.NoData = true
          }
        })
      }, 1000)
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    formatDateNow() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    getJoinMeet() {
      return new Promise(resolve => {
        this.initJoinMeetingData({
          uuid: this.$route.params.uuid
        }).then(res => {
          if (res) {
            this.JoinMeet = this.JoinMeetingData
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
              item.IsDb = true
              item.full_Name = item.name + ' ' + item.sname
              item.idCard = item.id_card
            })
            resolve(true)
          }
        }).catch(res => {
          if (res) {
            this.JoinMeet = this.JoinMeetingData
            resolve(false)
          }
        })
      })
    },
    DelData(idx, item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบรายชื่อผู้เข้าร่วมประชุม คุณ : " + item.full_Name + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/id/' + item.id, {
            active: '0',
            update_by: this.MeData[0].perid
          }, this.headerAxios).then(res => {
            if (res.data.status) {
              this.getJoinMeet()
              this.staffSel = ''
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลผู้เข้าร่วมประชุมคุณ : ' + item.full_Name + ' สำเร็จ'
              })
            } else {
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลบุคลากรได้'
              })
            }
          })
        }
      })
    },
    InsertJoinMeet() {
      var CheckCordi = false
      this.dialogLoading = true
      if (this.MeetingData[0].Count_cordi == '0') {
        CheckCordi = true
      } else {
        if (this.JoinMeet.length < parseInt(this.MeetingData[0].Count)) {
          CheckCordi = true
        } else {
          CheckCordi = false
        }
      }
      if (CheckCordi) {
        if (this.JoinMeet.length > 0) {
          if (this.JoinMeet.filter(item => item.uid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var staffDump = this.staffData.filter(item => item.perid == this.staffSel)
            if (staffDump.length > 0) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                D_meeting_uuid: this.$route.params.uuid,
                uid: staffDump[0].perid,
                name: staffDump[0].name,
                sname: staffDump[0].surname,
                id_card: staffDump[0].citizen_id,
                affiliation: staffDump[0].dep_name,
                position: staffDump[0].pos_name,
                phone: '',
                registerType_id: 0,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }, this.headerAxiosPUT).then(async res => {
                if (res.data.status) {
                  await this.getJoinMeet()
                  if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                    this.sendMailToOwner()
                  }
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                  })
                  this.staffSel = ''
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                  })
                }
              })
            } else {
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
              })
            }
          }
        } else {
          staffDump = this.staffData.filter(item => item.perid == this.staffSel)
          if (staffDump.length > 0) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
              D_meeting_uuid: this.$route.params.uuid,
              uid: staffDump[0].perid,
              name: staffDump[0].name,
              sname: staffDump[0].surname,
              id_card: staffDump[0].citizen_id,
              affiliation: staffDump[0].dep_name,
              position: staffDump[0].pos_name,
              phone: '',
              registerType_id: 0,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }, this.headerAxiosPUT).then(async res => {
              if (res.data.status) {
                await this.getJoinMeet()
                if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                  this.sendMailToOwner()
                }
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                })
                this.staffSel = ''
                this.dialogLoading = false
                // var Staff = this.staffData.filter(item => item.perid == this.staffSel)
                // if (Staff.length > 0) {
                //   this.JoinMeet.push({
                //     ...Staff[0],
                //     idx: this.JoinMeet.length + 1
                //   })
                //   this.JoinMeet.map((item, idx) => {
                //     item.idx = idx + 1
                //   })
                // }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                })
              }
            })
          } else {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
            })
          }
        }
      } else {
        this.dialogLoading = false
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถส่งรายชื่อ ผู้ร่วมเข้าประชุมได้ เนื่องจากจำนวนที่เปิดรับสมัครครบตามกำหนดแล้ว'
        })
      }
    },
    sendMailToOwner() {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        // perid_admin: this.MeData[0].perid,
        perid_admin: this.MeetingData[0].create_by,
        perid: this.MeetingData[0].create_by,
        headerName: 'แจ้งเตือนงานประชุม ' + this.MeetingData[0].Topic + ' มียอดผู้สมัครครบตามจำนานแล้ว',
        header: 'แจ้งเตือนงานประชุม ' + this.MeetingData[0].Topic + ' มียอดผู้สมัครครบตามจำนานแล้ว',
        body: 'ขณะนี้มียอดผู้สมัครเข้าร่วมประชุม ' + this.MeetingData[0].Topic + ' ครบตามจำนวน ที่เปิดรับสมัครแล้ว โปรดพิจารณาตรวจสอบเพื่อเพิ่มจำนวนผู้เข้าร่วม ผ่านระบบพัฒนาฝึกอบรมได้ตามลิงค์ => <a href="https://medhr.medicine.psu.ac.th/HrTrain2">ระบบพัฒนาฝึกอบรม</a>',
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        // this.InsertJoinMeet()
        if (this.MeetingData[0].Cordi == '0') {
          this.InsertJoinMeet()
        } else if (this.MeetingData[0].Cordi_Join_Data.target.length > 0 && this.MeetingData[0].Cordi_Join_Data.target[0].type == '1') {
          this.ChooseLeader()
        } else {
          this.ChooseEmpolyee_s()
        }
      }
    },
    ChooseLeader() {
      this.dialogLoading = true
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/supervisor_view/person_id/' + this.staffSel + '/?limit=1').then(res => {
        if (res.data) {
          this.InsertJoinMeet()
        } else {
          this.staffSel = ''
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากบุคลากรที่เลือก ไม่ตรงกับเงื่อนไขการเข้าร่วมประชุม'
          })
        }
        this.dialogLoading = false
      })
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      // var CheckQuotaProject = false
      var countPerson = 0
      var CheckGroupExample = []
      var CheckCordi = false
      this.dialogLoading = true
      if (this.MeetingData[0].Count_cordi == '0') {
        CheckCordi = true
      } else {
        if (this.JoinMeet.length < parseInt(this.MeetingData[0].Count)) {
          CheckCordi = true
        } else {
          CheckCordi = false
        }
      }
      if (CheckCordi) {
        this.staffData.map(async (staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.DataCondi.length > 0) {
              CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map(async (dep_quota, idx) => {
                    if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true
                        if (this.JoinMeet.length > 0) {
                          if (this.JoinMeet.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }

                            if (!CheckDupe) {
                              var staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                              if (staffDump.length > 0) {
                                await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                  D_meeting_uuid: this.$route.params.uuid,
                                  uid: staffDump[0].perid,
                                  name: staffDump[0].name,
                                  sname: staffDump[0].surname,
                                  id_card: staffDump[0].citizen_id,
                                  affiliation: staffDump[0].dep_name,
                                  position: staffDump[0].pos_name,
                                  phone: '',
                                  registerType_id: 0,
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }, this.headerAxiosPUT).then(async res => {
                                  if (res.data.status) {
                                    await this.getJoinMeet()
                                    if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                      this.sendMailToOwner()
                                    }
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                    })
                                    this.staffSel = ''
                                    this.dialogLoading = false
                                  } else {
                                    this.dialogLoading = false
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                    })
                                  }
                                })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                            if (staffDump.length > 0) {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                              D_meeting_uuid: this.$route.params.uuid,
                              uid: staffDump[0].perid,
                              name: staffDump[0].name,
                              sname: staffDump[0].surname,
                              id_card: staffDump[0].citizen_id,
                              affiliation: staffDump[0].dep_name,
                              position: staffDump[0].pos_name,
                              phone: '',
                              registerType_id: 0,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, this.headerAxiosPUT).then(async res => {
                              if (res.data.status) {
                                await this.getJoinMeet()
                                if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                  this.sendMailToOwner()
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                })
                                this.staffSel = ''
                                this.dialogLoading = false
                              } else {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                })
                              }
                            })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          if (this.MeetingData[0].Count_cordi == '0') {
                            if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                              if (staffDump.length > 0) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                D_meeting_uuid: this.$route.params.uuid,
                                uid: staffDump[0].perid,
                                name: staffDump[0].name,
                                sname: staffDump[0].surname,
                                id_card: staffDump[0].citizen_id,
                                affiliation: staffDump[0].dep_name,
                                position: staffDump[0].pos_name,
                                phone: '',
                                registerType_id: 0,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, this.headerAxiosPUT).then(async res => {
                                if (res.data.status) {
                                  await this.getJoinMeet()
                                  if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                    this.sendMailToOwner()
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                  })
                                  this.staffSel = ''
                                  this.dialogLoading = false
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                  })
                                }
                              })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {

                            countPerson = 0
                            this.JoinMeet.map(reqP => {
                              if (dep_quota.dep_id == reqP.dep_id) {
                                countPerson++
                              }
                            })

                            if ((this.JoinMeet.length + (parseInt(this.QuotaDepCount) - countPerson)) < parseInt(this.MeetingData[0].Count)) {
                              if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                                if (staffDump.length > 0) {
                                await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                  D_meeting_uuid: this.$route.params.uuid,
                                  uid: staffDump[0].perid,
                                  name: staffDump[0].name,
                                  sname: staffDump[0].surname,
                                  id_card: staffDump[0].citizen_id,
                                  affiliation: staffDump[0].dep_name,
                                  position: staffDump[0].pos_name,
                                  phone: '',
                                  registerType_id: 0,
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }, this.headerAxiosPUT).then(async res => {
                                  if (res.data.status) {
                                    await this.getJoinMeet()
                                    if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                      this.sendMailToOwner()
                                    }
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                    })
                                    this.staffSel = ''
                                    this.dialogLoading = false
                                  } else {
                                    this.dialogLoading = false
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                    })
                                  }
                                })
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                              })
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                        if (DepGroup.length > 0) {
                          if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                            CheckDepMatch = true
                            if (this.JoinMeet.length > 0) {
                              if (this.JoinMeet.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                                  if (staffDump.length > 0) {
                                  await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                    D_meeting_uuid: this.$route.params.uuid,
                                    uid: staffDump[0].perid,
                                    name: staffDump[0].name,
                                    sname: staffDump[0].surname,
                                    id_card: staffDump[0].citizen_id,
                                    affiliation: staffDump[0].dep_name,
                                    position: staffDump[0].pos_name,
                                    phone: '',
                                    registerType_id: 0,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }, this.headerAxiosPUT).then(async res => {
                                    if (res.data.status) {
                                      await this.getJoinMeet()
                                      if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                        this.sendMailToOwner()
                                      }
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                      })
                                      this.staffSel = ''
                                      this.dialogLoading = false
                                    } else {
                                      this.dialogLoading = false
                                      this.staffSel = ''
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                      })
                                    }
                                  })
                                  } else {
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                    })
                                  }
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                                })
                              }
                            } else {
                              staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                              if (staffDump.length > 0) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                D_meeting_uuid: this.$route.params.uuid,
                                uid: staffDump[0].perid,
                                name: staffDump[0].name,
                                sname: staffDump[0].surname,
                                id_card: staffDump[0].citizen_id,
                                affiliation: staffDump[0].dep_name,
                                position: staffDump[0].pos_name,
                                phone: '',
                                registerType_id: 0,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, this.headerAxiosPUT).then(async res => {
                                if (res.data.status) {
                                  await this.getJoinMeet()
                                  if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                    this.sendMailToOwner()
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                  })
                                  this.staffSel = ''
                                  this.dialogLoading = false
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                  })
                                }
                              })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                })
                              }
                            }
                          } else {
                            if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                              countPerson = 0
                              this.JoinMeet.map(reqP => {
                                if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                                  countPerson++
                                }
                              })

                              if ((this.JoinMeet.length + (parseInt(this.QuotaDepCount) - countPerson)) < parseInt(this.MeetingData[0].Count)) {
                                if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                                  if (staffDump.length > 0) {
                                  await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                    D_meeting_uuid: this.$route.params.uuid,
                                    uid: staffDump[0].perid,
                                    name: staffDump[0].name,
                                    sname: staffDump[0].surname,
                                    id_card: staffDump[0].citizen_id,
                                    affiliation: staffDump[0].dep_name,
                                    position: staffDump[0].pos_name,
                                    phone: '',
                                    registerType_id: 0,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }, this.headerAxiosPUT).then(async res => {
                                    if (res.data.status) {
                                      await this.getJoinMeet()
                                      if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                        this.sendMailToOwner()
                                      }
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                      })
                                      this.staffSel = ''
                                      this.dialogLoading = false
                                    } else {
                                      this.dialogLoading = false
                                      this.staffSel = ''
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                      })
                                    }
                                  })
                                  } else {
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                    })
                                  }
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                                })
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                } else {
                  if (this.JoinMeet.length < parseInt(this.MeetingData[0].Count)) {
                    if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      var staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                      if (staffDump.length > 0) {
                      await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                        D_meeting_uuid: this.$route.params.uuid,
                        uid: staffDump[0].perid,
                        name: staffDump[0].name,
                        sname: staffDump[0].surname,
                        id_card: staffDump[0].citizen_id,
                        affiliation: staffDump[0].dep_name,
                        position: staffDump[0].pos_name,
                        phone: '',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, this.headerAxiosPUT).then(async res => {
                        if (res.data.status) {
                          await this.getJoinMeet()
                          if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                            this.sendMailToOwner()
                          }
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                          })
                          this.staffSel = ''
                          this.dialogLoading = false
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                          })
                        }
                      })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                        })
                      }
                    } else {
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                      })
                    }
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถส่งรายชื่อ ผู้ร่วมเข้าประชุมได้ เนื่องจากจำนวนที่เปิดรับสมัครครบตามกำหนดแล้ว'
                    })
                  }
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงาน ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
                })
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map(async (dep_quota, idx) => {
                if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true
                    if (this.JoinMeet.length > 0) {
                      if (this.JoinMeet.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                        if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }

                        if (!CheckDupe) {
                          var staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                          if (staffDump.length > 0) {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                            D_meeting_uuid: this.$route.params.uuid,
                            uid: staffDump[0].perid,
                            name: staffDump[0].name,
                            sname: staffDump[0].surname,
                            id_card: staffDump[0].citizen_id,
                            affiliation: staffDump[0].dep_name,
                            position: staffDump[0].pos_name,
                            phone: '',
                            registerType_id: 0,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, this.headerAxiosPUT).then(async res => {
                            if (res.data.status) {
                              await this.getJoinMeet()
                              if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                this.sendMailToOwner()
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                              })
                              this.staffSel = ''
                              this.dialogLoading = false
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                              })
                            }
                          })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                            })
                          }
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                        })
                      }
                    } else {
                      if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                        if (staffDump.length > 0) {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                          D_meeting_uuid: this.$route.params.uuid,
                          uid: staffDump[0].perid,
                          name: staffDump[0].name,
                          sname: staffDump[0].surname,
                          id_card: staffDump[0].citizen_id,
                          affiliation: staffDump[0].dep_name,
                          position: staffDump[0].pos_name,
                          phone: '',
                          registerType_id: 0,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }, this.headerAxiosPUT).then(async res => {
                          if (res.data.status) {
                            await this.getJoinMeet()
                            if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                              this.sendMailToOwner()
                            }
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                            })
                            this.staffSel = ''
                            this.dialogLoading = false
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                            })
                          }
                        })
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                          })
                        }
                      } else {
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.project.Status_Count_Reg == '1') {
                        if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                          if (staffDump.length > 0) {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                            D_meeting_uuid: this.$route.params.uuid,
                            uid: staffDump[0].perid,
                            name: staffDump[0].name,
                            sname: staffDump[0].surname,
                            id_card: staffDump[0].citizen_id,
                            affiliation: staffDump[0].dep_name,
                            position: staffDump[0].pos_name,
                            phone: '',
                            registerType_id: 0,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, this.headerAxiosPUT).then(async res => {
                            if (res.data.status) {
                              await this.getJoinMeet()
                              if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                this.sendMailToOwner()
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                              })
                              this.staffSel = ''
                              this.dialogLoading = false
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                              })
                            }
                          })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                            })
                          }
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {

                        countPerson = 0
                        this.JoinMeet.map(reqP => {
                          if (dep_quota.dep_id == reqP.dep_id) {
                            countPerson++
                          }
                        })

                        if ((this.JoinMeet.length + (parseInt(this.QuotaDepCount) - countPerson)) < parseInt(this.MeetingData[0].Count)) {
                          if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                            if (staffDump.length > 0) {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                              D_meeting_uuid: this.$route.params.uuid,
                              uid: staffDump[0].perid,
                              name: staffDump[0].name,
                              sname: staffDump[0].surname,
                              id_card: staffDump[0].citizen_id,
                              affiliation: staffDump[0].dep_name,
                              position: staffDump[0].pos_name,
                              phone: '',
                              registerType_id: 0,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, this.headerAxiosPUT).then(async res => {
                              if (res.data.status) {
                                await this.getJoinMeet()
                                if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                  this.sendMailToOwner()
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                })
                                this.staffSel = ''
                                this.dialogLoading = false
                              } else {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                })
                              }
                            })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                          })
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                    if (DepGroup.length > 0) {
                      if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                        CheckDepMatch = true
                        if (this.JoinMeet.length > 0) {
                          if (this.JoinMeet.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                              if (staffDump.length > 0) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                D_meeting_uuid: this.$route.params.uuid,
                                uid: staffDump[0].perid,
                                name: staffDump[0].name,
                                sname: staffDump[0].surname,
                                id_card: staffDump[0].citizen_id,
                                affiliation: staffDump[0].dep_name,
                                position: staffDump[0].pos_name,
                                phone: '',
                                registerType_id: 0,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, this.headerAxiosPUT).then(async res => {
                                if (res.data.status) {
                                  await this.getJoinMeet()
                                  if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                    this.sendMailToOwner()
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                  })
                                  this.staffSel = ''
                                  this.dialogLoading = false
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                  })
                                }
                              })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                          if (staffDump.length > 0) {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                            D_meeting_uuid: this.$route.params.uuid,
                            uid: staffDump[0].perid,
                            name: staffDump[0].name,
                            sname: staffDump[0].surname,
                            id_card: staffDump[0].citizen_id,
                            affiliation: staffDump[0].dep_name,
                            position: staffDump[0].pos_name,
                            phone: '',
                            registerType_id: 0,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, this.headerAxiosPUT).then(async res => {
                            if (res.data.status) {
                              await this.getJoinMeet()
                              if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                this.sendMailToOwner()
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                              })
                              this.staffSel = ''
                              this.dialogLoading = false
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                              })
                            }
                          })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          countPerson = 0
                          this.JoinMeet.map(reqP => {
                            if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                              countPerson++
                            }
                          })

                          if ((this.JoinMeet.length + (parseInt(this.QuotaDepCount) - countPerson)) < parseInt(this.MeetingData[0].Count)) {
                            if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                              if (staffDump.length > 0) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                                D_meeting_uuid: this.$route.params.uuid,
                                uid: staffDump[0].perid,
                                name: staffDump[0].name,
                                sname: staffDump[0].surname,
                                id_card: staffDump[0].citizen_id,
                                affiliation: staffDump[0].dep_name,
                                position: staffDump[0].pos_name,
                                phone: '',
                                registerType_id: 0,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, this.headerAxiosPUT).then(async res => {
                                if (res.data.status) {
                                  await this.getJoinMeet()
                                  if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                                    this.sendMailToOwner()
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                                  })
                                  this.staffSel = ''
                                  this.dialogLoading = false
                                } else {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                                  })
                                }
                              })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  }
                }
              })
            } else {
              if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                staffDump = this.staffData.filter(item => item.perid == this.staffSel)
                if (staffDump.length > 0) {
                await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                  D_meeting_uuid: this.$route.params.uuid,
                  uid: staffDump[0].perid,
                  name: staffDump[0].name,
                  sname: staffDump[0].surname,
                  id_card: staffDump[0].citizen_id,
                  affiliation: staffDump[0].dep_name,
                  position: staffDump[0].pos_name,
                  phone: '',
                  registerType_id: 0,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }, this.headerAxiosPUT).then(async res => {
                  if (res.data.status) {
                    await this.getJoinMeet()
                    if (this.MeetingData[0].Count_cordi == '1' && this.JoinMeet.length == parseInt(this.MeetingData[0].Count)) {
                      this.sendMailToOwner()
                    }
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมประชุม คุณ : ' + this.staffData.filter(item => item.perid == this.staffSel)[0].full_Name + ' สำเร็จ!'
                    })
                    this.staffSel = ''
                    this.dialogLoading = false
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลบุคลากรได้'
                    })
                  }
                })
                } else {
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด ไม่พบข้อมูลบุคลากร!!'
                  })
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          }
        })
      } else {
        this.dialogLoading = false
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถส่งรายชื่อ ผู้ร่วมเข้าประชุมได้ เนื่องจากจำนวนที่เปิดรับสมัครครบตามกำหนดแล้ว'
        })
      }
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
  },
  async mounted() {
    this.dialogLoading = true
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    await this.saveSessions({
      session: ConstData.ConnectionHostHrTrain + this.$route.fullPath
    })
    await this.initMeData().then(res => {
      if (res) {
        this.init()
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
